export enum CreationTypeEnum {
  CLAIMED= 'CLAIMED',
  CREATED= 'CREATED',
}
